import React, { useRef } from "react";
import { MDBBtn } from 'mdb-react-ui-kit';
import {
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol,
  MDBRipple,
} from "mdb-react-ui-kit";
import "../css/circle.css";
import smartreportBanner from "../images/Technology/Final_patient_statements_and_payment_portal.webp";
import smartreportBanner1 from "../img/technologies/Infographic/Final patient statements and payment portal.png";
import comunicate from "../img/communicate.svg";
import digitalpayment from "../img/embrace digital payment.svg";
import textreminder from "../img/send text reminders.svg";
import "../css/servicesfont.css";
const Home = () => {
  const ref = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);

  const handleClick = () => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const handleClick1 = () => {
    ref1.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const handleClick2 = () => {
    ref2.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <MDBContainer fluid className="bg-light p-0">
      <div className="container py-5">

        <div class="button-overlay1 mb-4 mt-4 d-none d-lg-block" style={{ paddingLeft: '420px' }}>
          <img
            className="img-fluid"
            src={smartreportBanner}
            style={{ borderRadius: "10px", width: '60%' }}
            alt="Patient statement and payment portal"
          />
          <MDBRow>
            <MDBBtn color='link' rippleColor='dark' onClick={handleClick1} style={{ fontSize: '15px', color: 'white', fontFamily: 'Alegreya Sans', backgroundColor: 'transparent' }} className="button-overlay1">
    
            </MDBBtn>
            <MDBBtn color='link' rippleColor='dark' onClick={handleClick} style={{
              fontSize: '15px', color: 'white', fontFamily: 'Alegreya Sans', width: '210px', height: '160px',
              left: '45%', top: '160px', backgroundColor: 'transparent'
            }}>
          
            </MDBBtn>
            <MDBBtn color='link' rippleColor='dark' onClick={handleClick2} style={{ fontSize: '15px', color: 'white', width: '210px', left: '52%', top: '350px', height: '160px', fontFamily: 'Alegreya Sans', backgroundColor: 'transparent' }}>
  
            </MDBBtn>
          </MDBRow>
        </div>

        <div class="button-overlay1 mb-4 mt-4 d-lg-none">
          <img
            className="img-fluid"
            src={smartreportBanner1}
            style={{ borderRadius: "10px", width: '100%' }}
            alt="Patient statement and payment portal"
          />
        </div>


        <div ref={ref} className="card mt-4">
          <div className="row">

            <div className="col-lg-12 mb-5 p-4 d-none d-md-block">
              <div className="row">
                <div class="col-md-4 text-center mt-4">
                  <img src={comunicate} className="img-fluid" width={350} height={250} alt="Patient Statement" />
                </div>
                <div class="col-md-8" style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>Communicate the Way Your Patients Prefer</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500',textAlign:'justify' }}>
                    Communicate with patients in the way they prefer by e-delivering statements to those who opt for email communication. 
                   This approach not only reduces postage costs and shortens the time it takes for patients to receive their statements, 
                   but also makes it easier for them to pay promptly. By offering this convenience, your practice can improve collections, 
                   enhance  <a
                            href="https://acerhealth.com/services/revenue-cycle-management"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
              revenue cycle management,
                        </a>  
                    and support the efficiency of your medical billing services and medical billing outsourcing 
                   efforts—all while boosting patient satisfaction through preferred communication channels.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref={ref1} className="card p-4 mt-4">
          <div className="row">
            <div className="col-lg-12 mb-5">
              <div className="row">
                <div class="col-md-8" style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>Embrace Digital Payments</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500',textAlign:'justify' }}>
                    We stay ahead of changing trends and technology in the healthcare industry by offering flexible, modern payment solutions for your patients. 
                    Through the <b>AcerHealth Patient Payment Portal,</b> patients can make secure payments over the phone or through any digitally connected device, 
                    ensuring convenience and ease of use. Checks or credit card payments are deposited directly into your associated bank account, 
                    streamlining collections and supporting stronger revenue cycle management, enhanced medical billing services, and more efficient
                     <a
                            href="https://acerhealth.com/services/medical-billing-and-credentialing"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
           medical billing outsourcing
                        </a>  
                     —all while improving cash flow and patient satisfaction..
                  </p>
                </div>
                <div class="col-md-4 text-center ">
                  <img src={digitalpayment} className="img-fluid" width={350} height={250} alt="Embrace Digital Payment" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ref={ref2} className="card p-4 mt-4">
          <div className="row">
            <div className="col-lg-12 mb-5 d-none d-md-block">
              <div className="row">
                <div class="col-md-4 text-center ">
                  <img src={textreminder} className="img-fluid" width={350} height={250} alt="Send text reminders" />
                </div>
                <div class="col-md-8" style={{ marginTop: '100px' }}>
                  <h2 className="title AcerhealthTextPurple text-center fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>Send Text Reminders</h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign:"justify" }}>
                    Increase patient payments by sending simple and convenient balance reminders via text messages directly to their phones. This easy-to-use solution 
                    helps improve collections at the time of service and offers patients the clear communication they prefer, while reducing administrative effort for your team.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </MDBContainer>
  );
};

export default Home;
